import type { SurveyAnswersState as MedSurveyAnswersState } from "src/utils/redux/slices/surveyAnswers";

export enum MED_MEMBERSHIP_FACADE {
  DEFAULT = "default",
  MICRODOSE_WEGOVY_PILL = "microdose-wegovy-pill",
  WEGOVY_PILL = "wegovy-pill",
  WEGOVY_PEN = "wegovy-pen",
  FOUNDAYO_PILL = "foundayo-pill",
  ZEPBOUND_KWIKPEN = "zepbound-kwikpen",
}

declare module "src/utils/redux/slices/surveyAnswers" {
  interface SurveyAnswersState {
    medInterestSelection?: [string];
    membershipMedicationPreference?:
      | MED_MEMBERSHIP_FACADE
      | [MED_MEMBERSHIP_FACADE];
  }
}

function firstAnswer<T>(answer: T | T[] | undefined): T | undefined {
  return Array.isArray(answer) ? answer[0] : answer;
}

export function resolveMedMembershipFacade(
  surveyAnswers: MedSurveyAnswersState
): MED_MEMBERSHIP_FACADE {
  return (
    firstAnswer(surveyAnswers.membershipMedicationPreference) ??
    MED_MEMBERSHIP_FACADE.DEFAULT
  );
}
